import ThirtyMillionDevicesModal from 'src/components/Modals/ThirtyMillionDevicesModal.svelte';
import { PROMOTIONS } from 'src/constants';
import { home_data } from 'src/stores/account/user';
import { get } from 'svelte/store';

export const ThirtyMillionDevicesModalConfig = (forceShow = false) => {
	return {
		id: 'thirtyMillionDevices',
		component: ThirtyMillionDevicesModal,
		props: {
			showModal: true,
		},
		rules: [
			{
				check: () => {
					const now = new Date().getTime();
					const homeData = get(home_data);
					const hasBeenSeen = !!homeData?.promotions?.thirtyMillionDevices;

					return (
						now >= PROMOTIONS.THIRTY_MILLION_DEVICES.START_DATE &&
						now < PROMOTIONS.THIRTY_MILLION_DEVICES.END_DATE &&
						(!hasBeenSeen || forceShow)
					);
				},
				expected: true,
			},
		],
	};
};
